/**
 * Presentational metadata for printer connection interfaces — shared by the
 * Settings printer list and the Printer Helper's inline discovery list.
 */
import MuiLanIcon from '@mui/icons-material/Lan';
import MuiUsbIcon from '@mui/icons-material/Usb';
import MuiPrintIcon from '@mui/icons-material/Print';
import MuiBluetoothIcon from '@mui/icons-material/Bluetooth';

import type { StarPrinterInterface } from 'src/services/printers';

import type { MuiIconComponent } from 'src/components/mui-icon';

/** Icon used for a printer connection interface. */
export function interfaceIcon(type: StarPrinterInterface): MuiIconComponent {
  switch (type) {
    case 'lan':
      return MuiLanIcon;
    case 'bluetooth':
    case 'ble':
      return MuiBluetoothIcon;
    case 'usb':
      return MuiUsbIcon;
    default:
      return MuiPrintIcon;
  }
}

/** Friendly label for a configuration issue's interface. */
export function issueLabel(interfaceType?: StarPrinterInterface): string {
  switch (interfaceType) {
    case 'lan':
      return 'Wi-Fi / LAN';
    case 'bluetooth':
      return 'Bluetooth';
    case 'ble':
      return 'Bluetooth LE';
    case 'usb':
      return 'USB';
    default:
      return 'Discovery';
  }
}
